var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Modal',{attrs:{"id-modal":_vm.idModal}}),_vm._v(" "),_c('button',{staticClass:"d-lg-none bg-transparent border-0",attrs:{"aria-label":_vm.$t('main.header.nav.menuToggle')},on:{"click":function($event){return _vm.$bvModal.show(_vm.idModal)}}},[_c('i',{staticClass:"ph-bold ph-list",style:({ fontSize: '24px' })})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }